import type { ReactNode } from "react";

import { useDocumentTitle } from "../hooks/useDocumentTitle";

import { Footer } from "./Footer";
import { Header } from "./Header";

export function Page({
  title,
  heading,
  children,
}: {
  title?: string;
  heading?: string;
  children: ReactNode;
}) {
  useDocumentTitle(title);
  return (
    <>
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:absolute focus:left-2 focus:top-2 focus:z-50 focus:bg-card focus:px-3 focus:py-2"
      >
        Skip to content
      </a>
      <Header />
      <main id="main" className="bg-ivory">
        {heading ? (
          <div className="page-heading mx-auto max-w-6xl px-5 pb-6 pt-14 md:px-10 md:pb-8 md:pt-24">
            <h1 className="font-display rule-heading text-[2.15rem] leading-[1.05] text-ink md:text-[3.1rem]">
              {heading}
            </h1>
          </div>
        ) : null}
        {children}
      </main>
      <Footer />
    </>
  );
}
